import { createPinia, defineStore} from 'pinia';
import t from '@zh-or/lib';
import e from '@zh-or/lib/event.js';
import u from '@/lib/tools.js';
import api from '../api/api.js';
import req from '../api/request.config.js';

let pinia = createPinia();

let a = null;//sessionStorage.getItem('info');
console.log(a);
export const userStore = defineStore('user', {
    state() {
        return {
            userInfo: a || {
                create_time: "",
                id: 0,
                openid: "",
                personal: "",
                phone: '',
                real_name: '',
                team: "",
                type: "",
                update_time: '',
                url: ''
            }
        }
    },
    getters: {
        info: (state) => state,
        token: (state) => state.userInfo.openid,
    },
    actions: {
        setUserInfo(info) {

            /*if(info.img && info.img.length > 0) {
                info.url = req.host + info.img[0].url;
            } else {
                info.url = '';
            }*/

            t.clone(info, this.userInfo);

        },
        setInfo(phone, name) {
            this.userInfo.phone = phone;
            this.userInfo.real_name = name;
            //sessionStorage.setItem('info', this.userInfo);
        }
    }
});


export const store = pinia;
